import { createRoute } from '@tanstack/react-router';
import { Route as parent } from './site.tsx';
export const Route = createRoute({ getParentRoute: () => parent, path: 'form-entries' }).lazy(() =>
  import('./site-form-entries.lazy.tsx').then((module) => module.Route),
);
